export default __webpack_public_path__ + "static/summer_containers13-283f33ec1477fd5ceb5324554e69e25d.webp";